<template>
  <div class="container_box" id="video_box">
    <!--    <img @click="goPage" src="../../assets/comback_f.png" class="comback" />-->
    <!--          扫码关注全球灯云-->
    <div class="qr-code-box" v-if="!currItem.verify">
      <div class="txt">关注</div>
      <div class="txt">全球灯云</div>
      <div class="qr-code" @click="showQrCode">
        <van-icon name="qr" />
      </div>
    </div>
    <!--  弹框-->
    <!-- 分享弹框star -->
    <van-overlay :show="shareShow" @click="shareShow = false">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img v-if="currItem" class="img-goods goodsImg" :src="currItem.cover" alt="" />
          <div class="title">{{currItem.title}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>
      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
    <!-- 分享弹框end -->
    <van-overlay :show="qr_show" @click="qr_show = false">
      <div class="qr_zs_wrapper">
        <div class="block">
          <img :src="require('../../assets/'+appTheme+'/qr_zs.png')" alt="" />
          <span>扫一扫关注全球灯云</span>
        </div>

      </div>
    </van-overlay>
    <!--         扫码关注精品中山end -->
    <div class="van_swipe">
      <!--vant van-swipe 滑动组件 -->
      <van-swipe :show-indicators="false" @change="onChange" vertical :loop="false" ref="swipeToPage" :initial-swipe="initialSwipe">
        <van-swipe-item v-for="(item, index) in videoList" :key="index" class="product_swiper">
          <div class="video_container">
            <!--video属性
        webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
        微信内置x5内核，
        x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
        x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
        x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
        poster：封面
        src：播放地址
        -->
            <video class="video_box" loop
                   x5-video-player-fullscreen="true"
                   :poster="item.cover"
                   :src="item.play_url"
                   preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
                   x5-video-orientation
                   @click="pauseVideo" @ended="onPlayerEnded($event)"
            >
            </video>
            <!-- 封面 -->
            <img v-show="isVideoShow" class="play" @click="playvideo" :src="item.image"/>
            <!-- 播放暂停按钮 -->
            <img v-show="iconPlayShow" class="icon_play" @click="playvideo" :src="require('../../assets/'+appTheme+'/zt_icon.png')" />
          </div>
          <!-- 右侧头像、点赞、评论、分享功能 -->
          <!--          <div class="tools_right">-->
          <!--            <div class="tools_r_li">-->
          <!--              <img :src="item.tag_image" class="tag_image">-->
          <!--              <i class="iconfont icon-jiahao tag_add" v-show="!item.tagFollow"-->
          <!--                 @click="checkSubscribe(item,index)"></i>-->
          <!--              <i class="iconfont icon-duihao tag_dui" v-show="item.tagFollow"-->
          <!--                 :class="item.tagFollow?'tag_dui_active':''"></i>-->
          <!--            </div>-->
          <!--            <div class="tools_r_li" @click="changeFabulous(item,index)">-->
          <!--              <i class="iconfont icon-shoucang icon_right"-->
          <!--                 :class="item.fabulous?'fabulous_active':''"></i>-->
          <!--              <div class="tools_r_num">52.1w</div>-->
          <!--            </div>-->
          <!--            <div class="tools_r_li" @click="changeComment">-->
          <!--              <i class="iconfont icon-liuyan icon_right icon_right_change"></i>-->
          <!--              <div class="tools_r_num">12.5w</div>-->
          <!--            </div>-->
          <!--            <div class="tools_r_li" @click="changeShare">-->
          <!--              <i class="iconfont icon-iconfontforward icon_right"></i>-->
          <!--              <div class="tools_r_num">22.2w</div>-->
          <!--            </div>-->

          <!--          </div>-->

          <!--    顶部-->
          <div id="lp-header">
            <!-- 标题 在线人数 点赞 留言数 -->
            <div class="lp-ht-row justify-align">
        <span style="padding-left: 2.66667vw;">
          <van-icon @click="goPage" size="25" name="arrow-left" />
          <strong><van-notice-bar scrollable color="#ffffff" background="none" :text="item.title"/></strong>
        </span>
              <!--        <span>-->
              <!--          <van-icon style="margin-right: 0.66667vw;" name="friends-o" />3193-->
              <!--        </span>-->
              <!--        <span>-->
              <!--          <van-icon style="margin-right: 0.66667vw;" name="comment-o" />3193-->
              <!--        </span>-->
              <div class="left-justifying rt-box">
                <img @click="goVr" v-if="currItem.vr_url != null" class="vr-img" :src="require('../../assets/'+appTheme+'/zhibo_vr_des.png')" alt="">
                <div class="left-justifying live-num">
                  <img style="width: 3.46667vw;margin-right: 0.66667vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/zhibo_wode.png')" alt="" />
                  <span>{{currItem.likes}}</span> <span class="hint-num">播放</span>
                </div>
              </div>

            </div>
          </div>

          <!-- 左1按钮分组 -->
          <div class="lp-icon-group" id="lp-icon-1">
            <div class="lp-icon-item" @click="clickShowBag"><img :src="require('../../assets/'+appTheme+'/zhibo_red1.png')" alt=""></div>
            <!-- 1元购物 -->
            <div class="lp-icon-item" @click="clickShowBag"><img :src="require('../../assets/'+appTheme+'/zhibo_red2.png')" alt=""></div>
            <!-- 优惠券 -->
            <div class="lp-icon-item" @click="goQuan"><img :src="require('../../assets/'+appTheme+'/zhibo_red3.png')" alt=""></div>
            <!--      <div class="coupon-icon">-->
            <!--        <span>0</span>-->
            <!--      </div>-->
            <!-- 红包 -->
            <div class="lp-icon-item"><img :src="require('../../assets/'+appTheme+'/zhibo_red4.png')" alt=""></div>
            <!--      &lt;!&ndash; 付费礼物 &ndash;&gt;-->
            <!--      <div class="lp-icon-item"><img src="../../assets/zhibo_red1.png" alt=""></div>-->
          </div>
          <!-- 左1按钮分组end -->
          <!-- 右3按钮分组 -->
          <div id="lp-icon-4" class="lp-icon-group">
            <div class="lp-icon-item" @click="lickClick(currItem.id)"><img :src="require('../../assets/'+appTheme+'/zhibo_like2.png')" alt="">{{currItem.likes}}</div>
            <!-- 1元购物 -->
            <!--            <div class="lp-icon-item"><img src="../../assets/zhibo_pl.png" alt="">8888</div>-->
            <!-- 优惠券 -->
            <!--            <div class="lp-icon-item"><img src="../../assets/zhibo_fd.png" alt=""></div>-->
            <!-- 红包 -->
            <!--            <div class="lp-icon-item"><img src="../../assets/zhibo_img.png" alt=""></div>-->
            <!--            <div class="lp-icon-item"><img src="../../assets/zhibo_xian.png" alt=""></div>-->
            <div class="lp-icon-item" @click="shareClick"><img :src="require('../../assets/'+appTheme+'/zhibo_share_red.png')" alt=""></div>
          </div>
          <!-- 右3按钮分组end -->

          <!-- 底部作品描述 -->
          <!--          进度条开始-->
          <div class="production_box">
            <div class="trailer_progress_bar">
              <div class="proress_content_box">
                <p class="pro_pone">{{ currentTime }}</p>
                <div
                  ref="progress"
                  class="progress_bar_box"
                  @mousedown="getNowWh($event)"
                  @mouseup="mouseup($event)"
                >
                  <div
                    ref="onProgress"
                    :class="[ radiusLeft ? 'on_progress_bar_child border_Radius' : 'on_progress_bar_child',]">
            <span
              v-show="!radiusLeft"
              ref="mouseDom"
              class="mouse_down"
              @mousedown.stop="mousedown($event)"
              @mouseup.stop="mouseup($event)"
            ></span>
                  </div>
                </div>
                <p class="pro_pone">{{ duration }}</p>
              </div>
            </div>
          </div>
          <!-- 进度条end-->
          <!--    密码输入弹框-->
          <div class="pwd-box-swipe" v-if="currItem.verify">
            <div class="pwd-content-swipe">

              <div class="input-box-pwd">
                <div class="form-box-arrow" style="text-align: center;">
                  <van-icon class="arrow-box-pwd" name="arrow-left" @click="goPage" /> <span>密码验证</span>
                </div>
                <div class="form-box">
                  <div class="pwd-box-sec">
                    <input class="pwd" v-model="passwordCurr" placeholder="请输入密码" :type="passwordType" />
                    <span class="solts" @click="switchPasswordType">
                       <van-icon name="eye" v-if="passwordType==='text'" />
                       <van-icon name="closed-eye" v-if="passwordType==='password'"  />
                    </span>
                  </div>
                  <div class="btn-box">
                    <van-button :disabled="isDisablePwdCurr" class="btn-txt" round block type="primary" @click="onSubmitPwdSwipe">
                      进入
                    </van-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--    密码输入弹框-->
        </van-swipe-item>
      </van-swipe>
      <!--底部操作栏-->

    </div>
    <!--    消息-->
    <div class="fake-chat-msg" style="display: none">
      <div class="fake-chat-inner">
        <div class="item">
          <span>name：</span>
          <span>测试</span>
        </div>
      </div>
    </div>
    <!--说点什么-->
    <div id="fake-chat-form" style="display: none">
      说点什么
    </div>
    <div class="gift-box" style="display: none;"><img :src="require('../../assets/'+appTheme+'/zhibo_liwu.png')" alt="" /></div>
    <!--  购物袋-->
    <van-action-sheet v-model="shopBig" title=" " :closeable="true" :overlay="false">
      <div class="content-pop">
        <div class="p-title-box justify-align">
          <span class="title">共{{goodsList.length}}件商品</span>
          <div class="left-justifying">
            <!--            <div class="pop-item" style="margin-right: 5.33333vw;">-->
            <!--              <img src="../../assets/allShop.png" alt="" />-->
            <!--              店铺商品-->
            <!--            </div>-->
            <!--            <div class="pop-item">-->
            <!--              <img src="../../assets/shopCar.png" alt="" />-->
            <!--              购物车-->
            <!--            </div>-->
          </div>
        </div>
        <div class="goods-list-box">
          <div class="goods-item left-justifying" style="align-items: flex-start;" v-for="(item,index) in goodsList" :key="index" @click="goDes(item.id)">
            <div class="goods-img-box">
              <div class="hint-num">{{index+1}}</div>
              <img :src="item.image" alt="" />
            </div>
            <div class="goods-content">
              <div class="goods-title">{{item.name}}</div>
              <div class="goods-des justify-align">
                <div class="price-box">
                  ￥<span>{{item.price}}</span>
                </div>
                <div class="buy-news">马上抢</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!--    购物店end-->
    <!--    <div class="border_progress" :style="'width:'+videoProcess+'%'"></div>-->

    <!--    礼物弹框-->
    <div class="panel-wrapper" v-if="panel_is_show_gift">
      <div class="close-btn" @click="panel_is_show_gift=false"><span>关闭</span></div>
      <div class="panel">

        <div class="panel-content">
          <div class="gift-list">
            <div class="gift-item" v-for="(item,index) in giftList" :key="index">
              <img src="" alt="" />
              22.00
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 礼物弹框end -->
    <!-- 弹框-->
    <div id="panel-wrapper" class="panel-wrapper" v-if="panel_is_show">
      <div class="close-btn" @click="panel_is_show=false"><span>关闭</span></div>
      <div class="panel">
        <div class="panel-title">
          <div class="panel-title">
            <span :class="activeNav == 0?'current':''" @click="tabChange(0)">人机互动</span>
            <span :class="activeNav == 1?'current':''" @click="tabChange(1)">详情介绍</span>
            <span :class="activeNav == 2?'current':''" @click="tabChange(2)">共享照片</span>
            <span :class="activeNav == 3?'current':''" @click="tabChange(3)">富豪赏榜</span>
          </div>
        </div>
        <div class="panel-content" id="live-ranking-list-box">
          <div id="live-ranking-list1" v-if="activeNav==0">
            <!--           信息-->
            <div class="live-chat-msgs" :class="[ faceShow? 'msg-height':'' ]">
              <div class="item" style="align-items: start;" v-for="(item,index) in content" :key="index">
                <div class="left-justifying">
                  <div class="item-left">
                    <img src="" class="img-circle" alt="" />
                  </div>
                  <div class="item-right">
                    <div class="item-top justify-align">
                      <div class="item-name">人可何</div>
                      <div class="translate left-justifying">
                        <div class="tran active">中文</div><div class="tran">EN</div><div class="tran">多国语言</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item-content">
                  <div class="item-txt">{{item}}</div>
                </div>
              </div>
            </div>
            <!--            聊天end-->
            <!-- 输入框区域box -->
            <div class="input-box" ref="heightFace">
              <!-- 输入框区域 -->
              <div class="input-content left-justifying">
                <van-icon size="24" color="#fff" @click="faceContent" name="smile-o" />
                <input v-model="textConent" class="input-txt" type="text" />
                <!--        <van-icon size="24" color="#fff" @click="referContent" name="back-top" />-->
                <div class="send-btn" @click="referContent" name="back-top">发送</div>
              </div>
              <!-- 表情区域 -->
              <div class="browBox" v-if="faceShow">
                <ul>
                  <li v-for="(item,index) in faceList" :key="index" @click="getBrow(index)">{{item}}</li>
                </ul>
              </div>
            </div>
          </div>
          <div id="live-ranking-list2" class="live-ranking-list" v-else-if="activeNav==1">
            详情介绍
          </div>
          <div id="live-ranking-list3" class="live-ranking-list" v-else-if="activeNav==2">
            共享照片
          </div>
          <div id="live-ranking-list4" class="live-ranking-list" v-else>
            富豪赏榜
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框end-->
    <!--    密码输入弹框-->
    <div class="pwd-box" v-if="isShowPwd">
      <div class="pwd-content">
        <van-nav-bar
          left-arrow title="密码验证"
          @click-left="onClickLeft"
        />
        <div class="input-box-pwd">
          <div class="form-box">
            <div class="pwd-box-sec">
              <input class="pwd" v-model="password" placeholder="请输入密码" :type="passwordType" />
              <span class="solts" @click="switchPasswordType">
                 <van-icon name="eye" v-if="passwordType==='text'" />
                 <van-icon name="closed-eye" v-if="passwordType==='password'"  />
              </span>
            </div>
            <div class="btn-box">
              <van-button :disabled="isDisablePwd" class="btn-txt" round block type="primary" @click="onSubmitPwd">
                进入
              </van-button>
            </div>
          </div>
        </div>
        <tabBar></tabBar>
      </div>
    </div>
    <!--    密码输入弹框-->
  </div>
</template>

<script>

// 导入JSON格式的表情库
const appData = require("@/assets/emojis.json");
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
import tabBar from "@/components/tabBar";
import Vue from "vue";
import {
  Swipe,
  SwipeItem,
  Toast
} from 'vant';
import {getListData, zhoboListDes, zhoboDesLike, getWechat} from '@/api/zhibo'
Vue.use(Swipe, Toast).use(SwipeItem);
const jweixin = require('jweixin-module');
let videoProcessInterval;
import VueAliplayerV2 from 'vue-aliplayer-v2'
export default {
  name: "liveDes2",
  components: {
    // videoPlayer
    // VueAliplayerV2
    VueCanvasPoster,
    tabBar
  },
  data(){
    let u = navigator.userAgent;
    return{
      appTheme:this.$store.state.appTheme,
      passwordType: 'password',//输入框类型
      isShowPwd:false, // true 显示密码弹框 false 不显示
      password:'', // 密码
      passwordCurr:'',
      isDisablePwdCurr:false,
      isDisablePwd:false,
      options: { // 直播设置
        // source:'//player.alicdn.com/video/aliyunmedia.mp4',
        isLive: true, //切换为直播流的时候必填
        format: 'm3u8',  //切换为直播流的时候必填
        height:'100%',
        width:'100%',
        videoWidth:'100%',
        videoHeight:'100%',
        skinLayout:false,// 说明：功能组件布局配置，不传该字段使用默认布局。传 false 隐藏所有功能组件，请参照皮肤定制。
      },
      textConent: "",
      faceList: [],
      faceShow: false,
      getBrowString: "",
      content: ['非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好。',
        '非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好。', 'test'],
      goodsList: [],
      shopBig:false,
      giftList:[{},{},{},{},{}],
      panel_is_show_gift:false, // 礼物
      video_cover: require('@/assets/07hot1.png'),
      activeNav: 0,
      panel_is_show: false, // 说点什么
      controls:'',
      current: 0,
      videoList: [],
      isVideoShow: true, // 封面图
      playOrPause: true,
      video: null,
      iconPlayShow: true, // 暂停按钮显示
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
      isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      tabIndex: 0,
      showShareBox: false,//展示分享框
      commentPop: false,//是否展示评论弹框
      // 评论相关
      comment_text: '',//评论输入内容
      canSend: false,//是否可以发送
      videoComment: [],
      commentPlaceholder: '留下你精彩的评论吧',//评论Placeholder
      replayUserData: '',
      to_comment_id: '',
      videoProcess: 0,//视频播放进度
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: 'null',
      pVideo: null, //视频容器
      currItem: '',
      initialSwipe: 0, // 初始位置索引值
      currentTime: "00:00", //当前时间
      duration: "00:00", //总时长
      pvideo: null, //视频容器
      timer: null, //定时器
      radiusLeft: false,
      live_id: '',
      live_video_src: '', // 直播地址
      videoListTotal: [],
      qr_show: false,
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      shareShow:false,
      painting:{
        width: '510px',
        height: '600px',
        background: '#ffffff',
        borderRadius: '10px'
      }
    }
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    document.querySelector('body').setAttribute('style', 'background: #000;')
  },
  beforeDestroy() {		//在页面销毁之前移除body的属性，目的是设置的颜色只对当前页面有效
    console.log('离开界面')
    clearInterval(this.timer);
    this.timer = null;
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    // console.log('离开界面')
    this.shareShow = false
    clearInterval(this.timer);
    this.timer = null;
    document.querySelector('body').setAttribute('style', '')
    next()
  },
  watch: {
    //监听输入变化
    comment_text(newV, oldV) {
      newV == '' ? this.canSend = false : this.canSend = true
    }
  },
  mounted() {
    window.addEventListener("pagehide", this.pageHide);
  },
  destroyed() {
    //移除事件处理程序
    window.removeEventListener("pagehide", this.pageHide);
  },
  created() {
    console.log('44',typeof this.$route.query.id)
    console.log('id',this.$route.query.id)
    // this.live_id = this.$route.query.id

    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload",()=>{
      const itemObj = this.videoList[this.current]
      const item = JSON.stringify(itemObj)
      // console.log(item)
      this.$store.commit("setLiveItem",item)
    })

    // if (typeof this.currItem == "string"){ // 后退进来刷新
    //   console.log('后退进来')
    //   var currItem = JSON.parse(this.$store.state.liveItem)
    //   this.live_id = currItem
    // } else {
    //   console.log('正常进来')
    //   this.live_id = this.$route.query.id
    // }
    // console.log(this.$store.state.liveItem)


    if (this.$store.state.liveItem != ''){ // 后退进来
      const currItem = JSON.parse(this.$store.state.liveItem)
      this.live_id = currItem.id
      // console.log('$store')
    } else {
      // console.log('zheli')
      this.live_id = this.$route.query.id
    }
    console.log('id',this.live_id)
    this.getVideoDes()

  },
  methods: {
    onClickLeft(){
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    switchPasswordType() { // 显示密码
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
      // console.log(this.passwordType)
    },
    onSubmitPwd(){ // 密码提交
      if (this.password == ''){
        this.$toast('请输入密码')
      }else {
        this.getVideoDes()
      }
    },
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        console.log('ios')
      } else {
        console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      var data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          var weChat = res.data
          console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            console.log('ready',this.currItem)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              const id = that.currItem.id
              let http = window.location.protocol+'//'
              let url = window.location.hostname // 获取当前访问（域名）
              let urlPath  =http+url+`/liveDes2?id=${id}` // `https://jpzs-zst.itos.cn/liveDes2?id=${id}`
              console.log(urlPath)
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: that.currItem.title,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.currItem.cover,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: that.currItem.title,
                desc:' ',
                link: urlPath, // keyi
                imgUrl: that.currItem.cover,
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });
            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    //页面关闭或刷新时触发
    pageHide() {
      this.$store.commit("setWechatSignUrl", '');
    },
    showQrCode(){
      console.log('显示')
      this.qr_show = true
    },
    goVr(){
      // console.log(2222)
      // console.log(this.currItem.vr_url)
      // live_info
      var url = this.currItem.vr_url
      window.open(url);
      window.location.href = url
    },
    getVideoDes(){ // 获取视频详情
      let that = this
      let data = {
        password:this.password
      }
      zhoboListDes(this.live_id,data).then(res => {
        if(res.code == 200)
        {
          // console.log(res.data)
          this.isShowPwd = false
          let currData = res.data
          currData.verify = false
          that.currItem = currData

          this.getShareInfo()
          this.getList()
        }
        else if (res.code == 403 ){
          this.isShowPwd = true
          this.$toast(res.message)
        } else {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    lickClick(id){ // 点赞数量
      zhoboDesLike(id).then(res => {
        if(res.code == 200)
        {
          this.currItem.likes += 1
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    goDes(id){ // 去掉商品详情页
      // console.log('商品详情页')
      // console.log(this.live_id)
      var itemObj = this.videoList[this.current]
      var item = JSON.stringify(itemObj)
      // console.log(item)
      this.$store.commit("setLiveItem",item)
      this.$router.push({path:'/goodDetails',query: {id: id}})
    },
    getInit(){ // 初始化直播
      let player = new Aliplayer({
        id: 'J_prismPlayer',
        width: '100%', //容器的大小
        height: '100%', //容器的大小
        autoplay: true,
        prismType: 2,
        vid: '',
        accId: '',
        isLive: true,
        accSecret: '',
        apiKey: '',
        format: "m3u8",
        source: 'rtmp://live.aliyun.itos.cn/itkc/1117?auth_key=1637136604-0-0-255762dad3a0515b67d570008bf9a7f0',  //视频地址
        showBarTime: 3000000,
        cover: 'http://liveroom-img.oss-cn-qingdao.aliyuncs.com/logo.png'
      }, function (player) {
        console.log("播放器创建了。");
      });
    },
    // 表情
    faceContent() {
      this.faceShow = !this.faceShow;
      if (this.faceShow == true) {
        for (let i in appData) {
          this.faceList.push(appData[i].char);
        }
      } else {
        this.faceList = [];
      }
    },
    // 获取用户点击之后的标签 ，存放到输入框内
    getBrow(index) {
      for (let i in this.faceList) {
        if (index == i) {
          this.getBrowString = this.faceList[index];
          this.textConent += this.getBrowString;
        }
      }
    },
    // 将input的内容渲染到页面上
    referContent() {
      if (this.textConent == "") return alert("请输入内容");
      // 存入
      this.content.push(this.textConent);
      // 清空input数据
      this.textConent = "";
      // 关闭表情列表
      this.faceShow = false;
    },
    tabChange(e) {
      this.activeNav = e
    },
    panelShow(){
      this.panel_is_show = true
    },
    panelShowGift(){ // 礼物
      console.log(2222)
      this.panel_is_show_gift = true
    },
    panelShowToken(){ // 说点什么
        this.panel_is_show = true
    },
    clickShowBag(){ // 点击购物袋
     this.getDes()
    },
    goQuan(){
      this.$router.push('/discountCoupon')
    },
    getDes(){ // 获取购物袋商品
      zhoboListDes(this.live_id).then(res => {
        if(res.code == 200)
        {
          console.log(res.data.goods)
          if(res.data.goods.length>0){
            this.goodsList = res.data.goods
            this.shopBig = true
          }else {
            this.$toast('暂无商品')
          }

        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      getListData(data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data.data)
          // console.log(this.currItem)
          let arr = res.data.data
          console.log('正常进来')
          arr.unshift(this.currItem)
          let newArr = this.unique(arr); // 去掉重复
          // 再次把 type = live // 直播清掉
          let newArr2 = newArr // 清掉直播
          let newArrThree = [];
          for(let i = 0; i < newArr2.length; i++) {
            if(newArr2[i].live_type !== 'live') {
              newArrThree.push(newArr2[i])
            }
          }
          // console.log(newArrThree)
          that.videoList = newArrThree
          that.videoListTotal = newArr //  videoListTotal 用来判断数量总和

          that.live_id = that.videoList[0].id
          // console.log(that.live_id)
          // console.log(that.videoList)

          // setTimeout(() => {
          //   //通知父组件关闭
          //   console.log('播放')
          //   var video = document.querySelectorAll('video')[this.current];
          //   this.pVideo = document.querySelectorAll('video')[this.current];
          //   this.playvideo();
          // }, 400);

          if(!this.isiOS){ // 安卓
            console.log('安卓')
            setTimeout(() => {
              //通知父组件关闭
              console.log('播放')
              var video = document.querySelectorAll('video')[this.current];
              this.pVideo = document.querySelectorAll('video')[this.current];
              this.playvideo();
            }, 1000);
          }else { // ios
            console.log('ios')
            var video = document.querySelectorAll('video')[this.current];
            this.pVideo = document.querySelectorAll('video')[this.current];
            this.isVideoShow = true // 封面图显示
            this.iconPlayShow = true; // // 暂停按钮显示

          }



          // 加载状态结束
          this.loading = false;

          if (res.data.current_page == res.data.last_page){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data==0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    unique(newarr) { // 数组数据调用unique方法去除重复数据。
      const res = new Map();
      return newarr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    moreList(){ // 加载更多
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      var s_to = that.videoList.length
      console.log(s_to)
      this.current = s_to
      getListData(data).then(res => {

        if(res.code == 200)
        {

          // var arr = this.videoList.concat(res.data.data);
          var arr = this.videoListTotal.concat(res.data.data); //  videoListTotal 用来判断数量总和
          let newarr = this.unique(arr); // 去掉重复的
          // console.log('newarr',newarr)
          that.videoListTotal = newarr  // videoListTotal 用来判断数量总和
          this.initialSwipe = s_to
          // 再次把 type = live // 直播清掉
          let newArr2 = newarr // 清掉直播
          let newArrThree = [];
          for(let i = 0; i < newArr2.length; i++) {
            if(newArr2[i].live_type !== 'live') {
              newArrThree.push(newArr2[i])
            }
          }
          that.videoList = newArrThree // 赋值给video 列表
          this.isVideoShow = true // 封面图显示
          this.iconPlayShow = true; // // 暂停按钮显示

          setTimeout(() => {
            //通知父组件关闭
            console.log('播放')
            this.pVideo = document.querySelectorAll('video')[this.current];
            var video = document.querySelectorAll('video')[this.current];
            this.playvideo();
            Toast.clear()
          }, 920);
          // 加载状态结束
          this.loading = false;
          if (res.data.current_page == res.data.last_page) { // 数据全部加载完成
            this.finished = true;
            console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    //获取单个评论
    getCommentDetail(to_comment_id) {
      let obj = {
        action: 'show_comment_info',
        comment_id: to_comment_id
      };
      setTimeout(() => {
        let index;
        let item = res.data;
        this.videoComment.map((v, i) => {
          v.child_comment.map((v2, i2) => {
            if (v2.comment_id == to_comment_id) {
              index = i;
            }
          });
        });
        setTimeout(() => {
          //对评论重新排序，存在to_comment_id的时候排至第一个
          let firstComment = this.videoComment.splice(index, 1);
          this.videoComment.unshift(firstComment[0]);
          //重设回复人
          item.index = 0;
          item.index2 = 0;
          this.replayUserData = item;
          this.commentPlaceholder = `回复 @${item.nickname}：`;
          this.$refs.content.focus();
        }, 10)
      }, 500)
    },
    //检测评论内容
    checkComment() {
      if (this.comment_text == '') {
        Toast('评论内容不能为空')
      } else {
        let comment_id = 0, p_id = '', p_user_id = '', content = this.comment_text;
        if (this.replayUserData != '') {
          comment_id = this.replayUserData.comment_id;
          p_id = this.replayUserData.p_id;
          p_user_id = this.replayUserData.user_id;
        }
        this.sendComment(comment_id, p_id, p_user_id, content)
      }
    },
    //弹出评论窗口
    changeComment() {
      this.commentPop = true;
      this.videoComment = [];
      this.getComment()
    },
    //关闭评论弹窗
    closeComment() {
      this.commentPop = false;
      this.commentPlaceholder = '留下你精彩的评论吧';
      this.replayUserData = '';
    },
    //改变菜单
    changeTab(index) {
      this.tabIndex = index
    },
    //改变收藏状态
    changeFabulous(item, index) {
      this.videoList[index].fabulous = !this.videoList[index].fabulous
    },
    //展示分享弹窗
    changeShare() {
      this.showShareBox = true
    },
    //取消分享
    cancelShare() {
      this.showShareBox = false
    },
    //滑动改变播放的视频
    onChange(index) {
      //改变的时候 暂停当前播放的视频
      clearInterval(this.timer);
      this.currentTime = '00:00'
      this.passwordCurr = '';
      this.showShareBox = false; // 分享弹框隐藏
      this.current = index;
      this.live_id = this.videoList[this.current].id
      this.currItem = this.videoList[this.current]
      console.log(this.currItem)

      this.shopBig = false // 关闭购物袋
      this.shareShow = false
      this.posterUrl = ''
      // this.init()
      //非ios切换直接自动播放下一个
      if (index == this.videoList.length - 1) { // 最后一个 加载更多
        if (this.finished==false){
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
          });
          this.moreList()
        } else {
          this.$toast('加载完毕')
        }
      } else {
        console.log('不相等')
        if (!this.currItem.verify){ // true 需要密码 false 不需要
          this.videoProcess = 0;
          let video = document.querySelectorAll('video')[this.current];
          video.pause();

          if(!this.isiOS){
            this.isVideoShow = false // 封面图显示
            this.iconPlayShow = false; // // 暂停按钮显示
            setTimeout(() => {
              this.pauseVideo()
            }, 100)
          }else{
            //ios官方禁止video自动播放，未找到合适的方法，如果您发现了，麻烦告诉我一下谢谢啦
            // this.iconPlayShow = true; // // 封面图显示
            this.isVideoShow = true // 封面图显示
            this.iconPlayShow = true; // // 暂停按钮显示
          }
        }else {
          this.isVideoShow = true // 封面图显示
        }

      }


      this.getShareInfo() // 重新初始化微信注入
    },
    onSubmitPwdSwipe(){// 列表密码验证
      if (this.passwordCurr == ''){
        this.$toast('密码不能为空')
      } else {
        let data = {
          password:this.passwordCurr
        }
        zhoboListDes(this.currItem.id,data).then(res => {
          if(res.code == 200)
          {
            // console.log(res.data)
            this.passwordCurr = ''
            let curData = res.data
            let newArr2 =  this.videoList // 清掉直播
            newArr2.forEach((element,index) => {
              // console.log(element,"element")
              if (element.id == curData.id) {
                console.log(index)
                element.verify = false
                element.play_url = curData.play_url
              }
            });
            // console.log(newArr2)
            this.currItem.verify = false
            this.videoList = newArr2 // 赋值给video 列表

            let video = document.querySelectorAll('video')[this.current];
            video.pause();
            setTimeout(() => {
              this.pauseVideo()
            }, 300)

          } else if (res.code==403){ // 显示直播间密码错误
            // this.isShowPwd =true
            this.$toast(res.message)
          }
          else
          {
            this.$toast(res.message)
          }
        })
      }

    },
    // 开始播放
    playvideo(event) {
      let video = document.querySelectorAll('video')[this.current];
      // console.log(video)
      // console.log("playvideo：" + this.current);
      this.isVideoShow = false;
      this.iconPlayShow = false;
      this.showShareBox = false;
      video.play();
      this.pVideo = document.querySelectorAll('video')[this.current];
      this.timer = setInterval(this.setProgress, 60);
      console.log('总时长', video.duration)
      this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
      this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示

      window.onresize = function () {
        video.style.width = window.innerWidth + "px";
        video.style.height = window.innerHeight + "px";
      }

    },
    pauseVideo(){ //暂停\播放
      var video = document.querySelectorAll('video')[this.current];
      this.pVideo = document.querySelectorAll('video')[this.current];
      if (video.paused || video.ended) {
        console.log('播放')
        video.play();
        this.timer = setInterval(this.setProgress, 60);
        this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
        this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示
        console.log('shjian', video.currentTime)
        this.iconPlayShow = false // 暂停按钮隐藏
      } else {
        console.log('暂停')
        video.pause();
        this.iconPlayShow = true // // 暂停按钮显示
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //设置进度条
    setProgress() {
      this.pVideo = document.querySelectorAll('video')[this.current];
      var video = document.querySelectorAll('video')[this.current];
      let progress = this.$refs.progress[this.current]; //获取进度条父元素
      let onProgress = this.$refs.onProgress[this.current]; //获取变化进度条的元素
      let mouseDom = this.$refs.mouseDom[this.current];
      // console.log(mouseDom)
      this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
      this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示
      // console.log('总时长', this.duration)
      //换算,视频没有结束或者被暂停
      if (!video.ended) {
        this.radiusLeft = false;
        let percent = video.currentTime / video.duration; //得出比例
        mouseDom && (mouseDom.style.left = percent * progress.offsetWidth + "px");
        onProgress && (onProgress.style.width = percent * progress.offsetWidth + "px");
      } else {
        //视频已结束
        onProgress && (onProgress.style.width = "100%");
        this.radiusLeft = true;
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //点击当前位置，设置进度条
    getNowWh(event) {
      console.log(event)
      let ev = event || window.event;
      this.videoSeek(ev.offsetX);
    },
    //传入当前点击的偏移量，换算当前视频时间，并播放
    videoSeek(startx) {
      var video = document.querySelectorAll('video')[this.current];
      if (video.paused || video.ended) {
        video.play();
        this.enhanceVideoSeek(startx);
      } else {
        this.enhanceVideoSeek(startx);
      }
    },
    //根据鼠标拖动的距离，换算进度条
    enhanceVideoSeek(moveWidth) {
      console.log(moveWidth)
      var video = document.querySelectorAll('video')[this.current];
      clearInterval(this.timer);
      let progress = this.$refs.progress[this.current]; //获取进度条父元素
      let onProgress = this.$refs.onProgress[this.current]; //获取变化进度条的元素
      let percent = moveWidth / progress.offsetWidth;
      onProgress && (onProgress.style.width = percent * progress.offsetWidth + "px");
      video.currentTime = percent * video.duration;
      this.timer = setInterval(this.setProgress, 60);
    },
    vueTouch:function(s,e){
      console.log(s,e)
    },
    //鼠标按下
    mousedown(event) {
      console.log(event)
      let that = this;
      let ev = event || window.event;
      let _target = ev.target;
      let startx = ev.clientX;
      let sb_bkx = startx - ev.target.offsetLeft;
      let allwh = this.$refs.progress[this.current].clientWidth;
      let ww = document.documentElement.clientWidth;
      let wh = window.innerHeight;
      //阻止事件冒泡
      if (ev.preventDefault) {
        ev.preventDefault();
      } else {
        ev.returnValue = false;
      }
      //移动
      document.onmousemove = function (ev) {
        let evt = ev || window.event;
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        if (
          evt.clientY < 0 ||
          evt.clientX < 0 ||
          evt.clientY > wh ||
          evt.clientX > ww
        ) {
          return false;
        }


        let endx = evt.clientX - sb_bkx;
        //设置拖动有效区域
        if (endx > -1 && endx < allwh) {
          _target.style.left = endx + "px";
          that.enhanceVideoSeek(endx);
        } else {
          //超出区域，置空拖动事件
          document.onmousemove = null;
        }
      };
    },
    //鼠标放开
    mouseup(e) {
      document.onmousemove = null;
    },
    //订阅暂停事件
    stopPlay() {
      Watcher.$on("stop", (data) => {
        this.pauseVideo();
      });
    },
    /* 时间格式化 */
    timeFomat(time) {
      let h = Math.floor(time / 3600);
      let m = Math.floor((time % 3600) / 60);
      let s = Math.floor(time % 60);
      m = m >= 10 ? m : "0" + m;
      s = s >= 10 ? s : "0" + s;
      if (h === 0) {
        return m + ":" + s;
      }
      return h + ":" + m + ":" + s;
    },
    onPlayerEnded(player) { //视频结束
      this.isVideoShow = true
      this.current += this.current
    },
    goPage(){
      this.shareShow = false
      this.$store.commit("setLiveItem", '')
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    shareShowHide(){

      this.shareShow = false
    },
    shareClick(id){ // 生成二维码
      this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      var id = this.currItem.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/liveDes2?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      console.log(baseUrl)
      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          this.qrcodeUrl = qr;
          console.log(this.qrcodeUrl)
          this.drawPoster()
        }
      });

    },
    drawPoster(){

      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#ffa527',
            }
          },
          {
            type: 'image',
            url: this.currItem.cover,// this.currItem.cover// 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '50px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.currItem.title,
            css: [
              {
                top: '450px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px',
                textAlign: 'center'
              }
            ]
          },
          {
            type: 'image',
            url: this.qrcodeUrl,
            css: {
              width: '170px',
              height: '170px',
              top: '550px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "750px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          }
        ]
      }
    },
    //成功生成海报
    success(src) {
      console.log('成功')
      this.posterUrl = src;

      var tt = setTimeout( () =>{
        this.$toast.clear();
        this.shareShow = true
        console.log('shareShow',this.shareShow)
        clearTimeout(tt)
      },200)

      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
  }
}
</script>

<style lang="scss" scoped>
.pwd-box{
  position: fixed;width: 100%;height: 100%;z-index: 1009;background: #F5F5F5;top: 0;
  left: 0;

}
.input-box-pwd{
  margin: 40px 24px;background: #ffffff;padding: 30px 0 40px;border-radius: 10px;
  .form-box{
    padding: 20px;

  }
  .pwd-box-sec{
    width: 100%;background: #eae9e9;display: block;height: 88px;line-height: 88px; margin-bottom: 40px;
    font-size: 28px;border-radius: 10px;position:relative;
    .solts{
      position: absolute;right: 20px;top: 10px;font-size: 32px;color: #666666;
    }
  }
  .pwd{
    width: 100%;background: #eae9e9;display: block;height: 88px;line-height: 88px; margin-bottom: 40px;
    border: none;font-size: 28px;border-radius: 10px;
  }
  .btn-box{
    //margin-top: 40px;
  }
  .btn-txt{
    font-size: 30px;background: #FDD80D;border-color:#FDD80D;color: #333333;
  }
}
.pwd-box-swipe{
  position: absolute;width: 100%;height: 100%;z-index: 1009;background: #a2a2a2ab;top: 0;
  left: 0;
  .pwd-content-swipe{
    margin-top: 350px;
  }
  .form-box-arrow{
    padding-left: 20px;font-size: 32px;
    position: relative;
    .arrow-box-pwd{
      position: absolute;left: 20px;top: 5px;
    }
  }
}
/deep/.van-nav-bar{
  background: #FDD80D;
}
/deep/.van-nav-bar .van-icon {
  color:#333333;
}
.clear {
  clear: both;
}
.back_i{
  position: fixed;
  top: 20px;
  left: 10px;
  width: 28px;
  z-index: 10;
}


.video-player {
  height: 100vh;
  width: 100vw;
}
.title-box-top{
  color: #FFFFFF;margin-right: 20px;
  .share-box{
    display: inline-block;
  }
  .share-item{
    text-align: center;display: inline-block;margin-left: 30px;
    img{
      width: 50px;display: block;height: auto;
    }
  }
}
.product_swiper {
  width: 100vw;
  height: 100vh;
}

.van_swipe {
  width: 100vw;
  height: 100vh;
  /*max-width: 550px;*/
  /*margin: 0 auto;*/
  position: relative;
}

.van-swipe {
  width: 100%;
  height: 100%;
}

.container_box {
  width: 100vw;
  height: 100vh;
  background: #000;
}

.video_box {
  object-fit: fill !important;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

video {
  object-position: 0 0;
}

.icon_play {
  position: absolute;
  top: 44%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 999;
  height: 120px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.play,
.platStart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
}

/*头像， 点赞，转发 */
.tag_image {
  width: 50px;
  height: 50px;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 50%;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0px 0px 10px #9d9d9d;
}


.tag_dui_active {
  opacity: 0;
  animation: showFollow 1.4s ease-in-out 0s;
}

.tag_add_num {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
}

@keyframes showFollow {
  0% {
    opacity: 1;
    color: #fff;
    background: #F44;
    transform: rotate(-180deg) scale(1);
  }
  35% {
    opacity: 1;
    color: #f44;
    background: #fff;
    transform: rotate(0deg) scale(1.2);
  }
  80% {
    opacity: 1;
    color: #f44;
    transform: scale(1.2);
  }
  100% {
    opacity: 0;
    display: none;
    color: #f44;
    transform: scale(0);
  }
}

.tools_right {
  z-index: 1001;
  position: absolute;
  right: 16px;
  bottom: 180px
}

.tools_r_li {
  margin-bottom: 20px;
  color: #fff;
  font-size: 14px;
  position: relative;
}

.tools_r_li:last-child {
  margin-bottom: 0px;
}

.icon_right {
  margin-bottom: 5px;
  font-size: 42px;
  display: block;
  text-shadow: 0px 0px 10px #9d9d9d;
  /*transition: .5s;*/
}

.production_box {
  z-index: 1001;
  position: absolute;
  /* right: 16px; */
  bottom: 0;
  text-align: left;
  padding: 30px 0 40px;
  color: #fff;
  width: 100%;
  left: 0;
  box-sizing: border-box;
  background: linear-gradient(transparent, #000);
  /* 标准的语法 */
}

.production_name {
  font-size: 28px;
  margin-bottom: 10px;
}

.production_des {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 62px;
  font-size: 26px;margin-left: 20px;padding: 20px;
}


.production_title {
  margin-left: 4px;
}

//.border_progress {
//  width: 0;
//  height: 1px;
//  background: #bababa;
//  position: absolute;
//  top: 0;
//  transition: .1s all;
//}


.icon-shoucang {
  transition: .5s all;
}

//.fabulous_active {
//  color: #f44;
//  animation: showHeart .5s ease-in-out 0s;
//}

/*animation-name：用来调用@keyframes定义好的动画，与@keyframes定义的动画名称一致*/
/*animation-duration ：指定元素播放动画所持续的时间*/
/*animatino-timing-function ： 和transition中的transition-timing-function 中的值一样。根据上面@keframes中分析的animation中可能存在多个小动画，因此这里的值设置是针对每一个小动画所在时间范围内的属性变换速率。*/
/*animation-delay：定义在浏览器开始执行动画之前等待的时间，这里是指整个animation执行之前的等待时间，而不是上面说的多个小动画*/
/*animation-iteration-count：定义动画的播放次数，其通常为整数，默认是1,；取值为infinite，动画将无限次的播放。*/
/*animation-direction：主要用来设置动画播放方向*/
@keyframes showHeart {
  0% {
    color: #f44;
    transform: scale(1);
  }

  25% {
    color: #fff;
    transform: scale(0);
  }

  80% {
    color: #f44;
    transform: scale(1.2);
  }

  100% {
    color: #f44;
    transform: scale(1);
  }
}

/*分享样式*/
.share_hover {
  position: fixed;
  display: none;

}

.share_box {
  position: fixed;
  bottom: -300px;
  width: 100%;
  z-index: 1002;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: .5s;
}

.share_tips {
  text-align: center;
  line-height: 38px;
  color: #333;
}

.share_ul {
  box-sizing: border-box;
  padding: 0 25px 25px;
  border-bottom: 1px solid #e8e8e8;
}

.share_li {
  float: left;
  width: 33%;
  text-align: center;
}

.share_li i {
  font-size: 44px;
}

.share_cancel {
  text-align: center;
  line-height: 48px;
  color: #777;
  text-align: center;
}

.pengyouquan {
  color: #47D000;

}

.pengyouquan_li {
  animation: rotating 8s linear infinite
}

@keyframes rotating {
  from {
    transform: rotate(0)
  }

  to {
    transform: rotate(360deg)
  }
}

.weixin {
  color: #20CA2E;
}

.lianjie {
  color: #cdcdcd;
}

.share_active {
  bottom: 0px;
}

/*评论样式*/
::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.20);
}

:-moz-placeholder {
  color: rgba(0, 0, 0, 0.20);;
}

::-moz-placeholder {
  color: rgba(0, 0, 0, 0.20);
}

:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.20);
}

.comment_container {
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.comment_box {
  padding: 0 15px 52px 15px;
}

.comment_top {
  text-align: center;
  font-size: 26px;
  color: #000;
  line-height: 40px;padding-top: 20px;
}

.guanbi3 {
  float: right;
  font-size: 12px;
  padding: 0 10px;
  position: absolute;
  right: 6px;
}

.comment_li {
  margin-bottom: 20px;
  font-size: 14px;
  text-align: left;
}

.comment_author_left {
  float: left;
}

.comment_author_left img {
  width: 55px;
  height: 55px;
  border-radius: 50%;display: inline-block;margin-right: 10px;
}

.comment_author_right {
  margin-left: 46px;
  padding-top: 4px;
}

.comment_author_top {
  position: relative;
}

.comment_author_name {
  margin-bottom: 6px;
  color: #777;font-size: 28px;
}

.icon-shoucang1_box {
  position: absolute;
  right: 0px;
  top: 0;
  text-align: center;
  color: #777;
}

.comment_author_text {
  color: #555;font-size: 26px;
  margin-bottom: 10px;
  padding-right: 35px;
}

.comment_replay_box {
  padding-left: 46px;
  box-sizing: border-box;
}

.comment_replay_li {
  margin-bottom: 10px;
}

.comment_replay_left {
  float: left;
}

.comment_replay_left img {
  width: 60px;
  height:60px;
  border-radius: 50%;
}

.comment_replay_right {
  margin-left: 35px;
  padding-top: 2px;
}

.comment_replay_top {
  position: relative;
  margin-bottom: 6px;
}

.comment_replay_text {
  padding-right: 35px;
  margin-bottom: 10px;
  color: #555;
}

.comment_author_text span, .comment_replay_text span {
  color: #999;
  font-size: 24px;
  margin-left: 6px;
}

.shoucang1_num {
  text-align: center;
  width: 30px;
  font-size: 26px;
  /* right: -4px; */
  position: relative;
}

.comment_ul {
  height: 400px;
  overflow-y: auto;margin-top: 50px;
}

.comment_input_box {
  position: fixed;
  bottom: 0;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  padding: 10px 15px;
  box-sizing: border-box;
}

/*.comment_form {*/
/**/
/*}*/
.comback{
  width: 54px;height: auto;display: block;left: 30px; top: 30px;z-index: 22;position: absolute;
}
.comment_input {
  border: none;
  resize: none;
  width: 80%;
  float: left;
  color: #555;
  caret-color: #f44;
}

.comment_input_right {
  float: right;
}

.comment_i {
  font-size: 26px;
  color: #999;
  transition: .3s;
}

.comment_i_active {
  color: #f44;
}

.icon-zanwupinglun {
  font-size: 100px;
  color: #777;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(80px);
}

.v-enter-active,
.v-leave-active {
  transition: all .5s ease;
}

/*添加进场效果*/
.v-move {
  transition: all 1s ease;
}

.v-leave-active {
  position: absolute;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.love_active {
  color: #f44;
}

.trailer_progress_bar {
  //width: 100%;
  padding: 0 10px;
  overflow: hidden;
  position: relative;
  .proress_title {
    width: 100%;
    height: 100px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    p {
      color: #fff;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .proress_content_box {
    width: 100%;
    overflow: hidden;
    display: flex;
    //padding: 0 24px;
    justify-content: center;
    p {
      color: #fff;
      font-weight: 400;
      font-size: 24px;margin: 0;
    }
    .pro_pone {
    }
    .progress_bar_box {
      flex: 0.9;
      margin: 6px 16px 0 16px;
      height: 8px;
      background: rgba(205, 206, 209, 0.2);
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      .on_progress_bar_child {
        width: 0;
        height: 100%;
        background: #cdced1;
        border-radius: 4px 0px 0px 4px;
        // overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1001;
        .mouse_down {
          position: absolute;
          width: 5px;
          height: 16px;
          top: 50%;
          margin-top: -8px;
          left: 100%;
          background: #ff5001;
          border-radius: 3px;
          z-index: 1002;
          cursor: pointer;
        }
      }
      .on_progress_bar_child.border_Radius {
        border-radius: 4px;
      }
    }
  }
}
.live-wrapper {
  .rt-box{
    padding-right: 20px;

    div{
      background: rgba(0,0,0,0.5);padding: 10px 10px;
      color: #FFFFFF;font-size: 24px;margin-left: 10px;border-radius: 50px;
      img{
        width: 18px;height: auto;margin-left: 4px;margin-right:5px;
      }
      .hint-num{
        font-size: 18px;font-weight: normal;margin-left: 10px;display: inline-block;margin-top: -5px;
      }
    }
  }
  background: #000;
  position: relative;
  .lp-player-box{
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    .video-box{
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100vh;left: 0;
      object-fit: cover;top: 0;
    }
    .player{
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100vh;
      object-fit: fill;left: 0;top: 0;
    }
  }
  .lp-player-btn{
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 999;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 50px;
    color: #fff;
    background: rgba(0,0,0,.3);top: 0;
  }
  .fake-chat-msg{
    width: 365px;
    position: absolute;
    left: 24px;
    bottom: 120px;
    z-index: 2;
    height: 150px;
    overflow: hidden;
    .fake-chat-inner{
      position: relative;
      .item{
        border-radius: 15px;
        background: #383838;
        color: #fff;
        padding: 10px 10px;
        margin-bottom: 5px;text-align: left;font-size: 24px;
      }
      span:nth-child(1) {
        color: #FFECBD;
      }
    }
  }
}

#lp-header{
  color: #fff;
  z-index: 2;
  position: absolute;
  width: 100%;top: 0;left: 0;z-index: 1000;
  .lp-ht-row{
  }
  .lp-ht-row:nth-child(1) {
    background: linear-gradient(rgba(0,0,0,.8),transparent);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .lp-ht-row:nth-child(1) span {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    //padding: 15px;
  }
  .lp-ht-row:nth-child(1) span:nth-child(1) strong {
    position: relative;
    font-size: 26px;
    font-weight: 400;
    width: 300px;
    height: 80px;
    overflow: hidden;
  }
  .vr-img{
    width: 62px;height: auto;margin-right: 10px;display: inline-block;
  }
  .live-num{
    padding-right: 15px;padding-left: 20px;
    img{
      width: 18px;height: auto;display: inline-block;margin-right: 5px;
    }
  }
  //.lp-ht-row:nth-child(1) span:nth-child(1) strong strong {
  //  width: 500%;
  //  position: absolute;
  //  animation: 10s lp-header-move infinite linear;
  //  left: 0;
  //  top: 0;
  //}
}
.lp-icon-group{
  position: absolute;z-index: 1000;
  .lp-icon-item{
    //width: 60px;
    //height: 60px;
    //border: 1px solid #3c8ee5;
    //margin-bottom: 10px;

    color: #FDD80D;font-size: 24px;
    img{
      width: 80px;
      height: auto;display: block;
    }
  }
}
#lp-icon-1{
  top: 120px;
  left: 15px;
}
#lp-icon-4{
  bottom: 350px;width: 100px;display: inline-block;text-align: center;
  right: 15px;
  .lp-icon-item{
    margin-bottom: 20px;text-align: center;
    img{
      margin: 0 auto;
    }
  }
}
#fake-chat-form {
  position: absolute;
  left: 24px;
  bottom: 80px;
  width: 350px;
  z-index: 1000;
  border-radius: 30px;
  background: #383838;
  color: #fff;
  padding: 10px 10px;
  font-size: 24px;text-align: left;
}
.gift-box{
  position: absolute;
  left: 420px;
  bottom: 80px; z-index:2; border-radius: 30px;
  background: #383838;padding: 10px;
  img{
    width: 34px;height: auto;display: block;margin: 0 auto;
  }
}
.live-ranking-list{
  height: 610px;
  overflow-y: scroll;
}
.input-box{
  //position: fixed;
  //width: 100%;left: 0; bottom: 120px;
  background: #D0E1CB;
  .send-btn{
    width: 120px;
    color: #FFFFFF;
    background: #55BB3A;padding: 12px 0;
    border-radius: 32px;margin-left:26px;
  }
  .input-content{
    padding: 20px 20px;
    input{
      //width: 80%;margin: 0 15px;height: 60px;line-height: 60px;padding: 0 5px;
      width: 510px;margin-left: 10px;
      height: 66px;line-height: 66px;
      background: #FFFFFF;padding: 0 10px;
      border-radius: 33px;border: none;color: #282828;
    }
  }
  .browBox {
    width: 100%;
    height: 200px;
    background: #e6e6e6;
    //position: absolute;
    //bottom: 0px;
    overflow: scroll;
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
      li {
        width: 14%;
        margin: 5px 0;
        font-size: 42px;
        list-style: none;
        text-align: center;
      }
    }
  }
}
.live-chat-msgs{
  //padding-bottom: 120px;
  height: 510px;
  overflow-y: scroll;
  .item{
    padding: 15px 0;font-size: 26px;
    .item-content{
      .item-txt{
        padding: 5px 30px;text-align: left;font-size: 26px;
      }

    }
    .item-left{
      width: 16%;
      img {
        width: 80px;background: #cccccc;border-radius: 80px;height: 80px;
      }
    }
    .item-right{
      width: 80%;margin-left: 15px;
      .item-top{
        padding-bottom: 10px;
      }
      .translate{
        div{
          margin-right: 10px;color: #EDA10E;
          background: #FFFFFF;
          border: 2px solid #EDA10E;
          border-radius: 5px;padding: 5px 10px;
        }
        .active{
          background: #EDA10E;color:#ffffff;
        }
      }

    }
  }
}
.click-icon{
  position: absolute;left: 50%;top: 50%;
  color: #ea5e2d;z-index: 888;font-size: 50px;
}
.content-pop{

  .p-title-box{
    padding: 20px 100px 20px 20px;
    .title{
      font-weight: bold;
      color: #282828;font-size: 32px;
    }
    .pop-item{
      font-size: 18px;text-align: center;
      img{
        width: 40px;height: auto;display: block;margin: 0 auto;
      }
    }
  }
  .goods-list-box{
    padding: 0 15px 20px;
    .goods-item{
      margin-bottom: 20px;
      .goods-img-box{
        border-radius: 30px; width: 240px;
        height: 240px;overflow: hidden;position: relative;
        img{
          width: 240px;
          height: 240px;display: block;
        }
        .hint-num{
          text-align: center;
          background: rgba(0, 0, 0, 0.5);border-radius: 30px 0px 10px 0px;width: 64px;
          font-size: 22px;font-weight: 400;padding: 10px 0;
          color: #FFFFFF;
          position: absolute;left: 0; top: 0;
        }
      }
      .goods-content{
        width: 450px;margin-left: 20px;position: relative;height: 240px;
        .goods-title{
          text-align: left;font-size: 28px;line-height:40px;
        }
        .goods-des{
          position: absolute;bottom: 0;left: 0;width: 100%;
          .price-box{
            font-weight: 400;
            color: #F23926;
            span{
              font-weight: bold;
              color: #F23926;font-size: 50px;
            }
          }
          .buy-news{
            width: 127px;
            padding: 10px 15px;
            background: #FDD80D;
            border-radius: 32px;font-weight: bold;text-align: center;
            color: #F23926;
          }
        }
      }
    }
  }
}
/deep/ .van-popup{
  background: rgba(255, 255, 255, 0.8);z-index: 9999!important;
}
.van-action-sheet__close{
  color: #adadad;z-index: 9999!important;
}
.panel-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  //transition: all 0.8;
  .close-btn {
    text-align: center;
    padding: 10px;
    margin-bottom: 20px;
    span {
      background: rgba(0,0,0,.5);
      color: #fff;
      padding: 10px 15px;
      font-size: 26px;
      border-radius: 5px;
    }
  }
  .panel {
    background: rgba(0,0,0,.5);
    color: #fff;
    height: 720px;
    margin-bottom: 0;
    border: 1px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    .panel-title {
      //transition: all .8;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center; width: 100%;
      span {
        display: inline-block;
        width: 25%;padding: 20px 0;
      }
      .current {
        transition: all .8;
        background: rgba(0,0,0,.8);
      }
    }
    .panel-content{
      color: #fff;
      background: rgba(0,0,0,.8);
      //height: 100%;
      //overflow-y: scroll;
      //-webkit-overflow-scrolling: touch;
    }
  }
}
.gift-list {
  padding: 15px 0;text-align: left;margin-left: 5px;
  .gift-item{
    width: 160px;display: inline-block;margin: 0 12px 20px;text-align: center;
    img{
      width: 160px;height: 160px;background: #cccccc;display: block;margin-bottom: 20px;
    }
  }
}
.fake-chat-msg{
  width: 365px;
  position: absolute;
  left: 24px;
  bottom: 120px;
  z-index: 2;
  height: 150px;
  overflow: hidden;
  .fake-chat-inner{
    position: relative;
    .item{
      border-radius: 15px;
      background: #383838;
      color: #fff;
      padding: 10px 10px;
      margin-bottom: 5px;text-align: left;font-size: 24px;
    }
    span:nth-child(1) {
      color: #FFECBD;
    }
  }
}
.van-overlay{
  background: none;z-index: 9999;
}
.qr-code-box{
  position: absolute;bottom: 110px;z-index: 999;right: 30px;text-align: right;
  font-size: 22px;
  font-weight: bold;
  color: #FDD80D;
  line-height: 26px;
  .qr-code{
    width: 74px;
    height: 74px;
    background: #FFFFFF;
    border-radius: 6px;color: #999;font-size: 70px;text-align: center;display: inline-block;margin-top: 15px;
  }
}
.qr_zs_wrapper{
  display: flex;
  align-items: center;
  justify-content: center;text-align: center;position: relative;
  height: 100%;
  .block {
    width: 350px;
    height: 350px;
    background-color: #fff;border-radius: 8px;position: absolute;bottom: 112px;right: 5px;
    img{
      width: 260px;
      height: 260px;display: block;margin: 20px auto 10px;
    }
  }

}
.share-poster-wrapper{
  position: fixed;left: 0;top: 0;width: 100%;height: 100%;z-index: 8888;
  text-align: center;
  .poster-url{
    width: 520px;
    height: 890px;display: block;margin: 0 auto;
  }
  .poster-bg{
    position: fixed;left: 0;top: 0;width: 100%;height: 100%;z-index: 8888;
    text-align: center;background: rgba(50, 47, 47, 0.1);
  }
}
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 80px auto 30px;text-align: center;
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
  .imageWrapper{
    width: 520px;
    height: 890px;
    background: #FFFFFF;
    border: 6px solid #FDD80D;
    border-radius: 20px;margin: 0 auto;text-align: center;
    .goodsImg{
      width: 370px;
      height: 370px;
      border-radius: 10px;margin-top: 50px;margin-bottom: 40px;
    }
    .title{
      width: 370px;text-align: center;margin-bottom: 30px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .qr-code-img{
      width: 170px;
      height: 170px;margin:50px auto 20px;
    }
    .hint{
      color: #E43A0D;
    }
  }
}
</style>

